import Icon from '../components/Icon.vue'

Icon.register({
  'angle-double-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0l-96.5-96.3-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.6c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-0.1zM143 63.7c9.4-9.4 24.6-9.4 33.8 0l136 136c9.4 9.3 9.4 24.5 0 33.9l-22.6 22.6c-9.3 9.4-24.5 9.4-33.9 0l-96.4-96.4-96.4 96.4c-9.3 9.4-24.5 9.4-33.9 0l-22.6-22.6c-9.4-9.3-9.4-24.5 0-33.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-up.js
// module id = 602
// module chunks = 0